import { useQuery } from '@tanstack/react-query';
import { fetchAllAliases } from '../services/AdministrationService';

export const useAliasesByOwner = () => {
    const query = useQuery({
        queryKey: ['admin', 'aliases', 'by-owner'],
        queryFn: async () => {
            const result = await fetchAllAliases({ limit: 1000 });
            
            const countsByOwner: Record<string, number> = {};
            result.items.forEach((alias: any) => {
                const owner = alias.createdByUsername || 'Unknown';
                countsByOwner[owner] = (countsByOwner[owner] || 0) + 1;
            });
            
            return Object.entries(countsByOwner).map(([name, value]) => ({
                name,
                value
            }));
        }
    });

    return {
        data: query.data || [],
        loading: query.isLoading
    };
};
